export interface PlayerRankData {
  id: string;
  username: string;
  joinedAt: string;
  coins: number;
  ownedBlocks: number;
  totalBuildings: number;
  hourlyIncome: number;
  auctionWins: number;
}

export const mockPlayers: PlayerRankData[] = [
  {
    id: "user-001",
    username: "Tanaka_Hiroshi",
    joinedAt: "2025-01-01",
    coins: 48200,
    ownedBlocks: 12,
    totalBuildings: 18,
    hourlyIncome: 720,
    auctionWins: 5,
  },
  {
    id: "user-002",
    username: "Pierre_Dupont",
    joinedAt: "2025-01-15",
    coins: 31500,
    ownedBlocks: 9,
    totalBuildings: 14,
    hourlyIncome: 580,
    auctionWins: 3,
  },
  {
    id: "user-003",
    username: "James_Smith",
    joinedAt: "2025-02-01",
    coins: 27800,
    ownedBlocks: 8,
    totalBuildings: 11,
    hourlyIncome: 430,
    auctionWins: 4,
  },
  {
    id: "user-004",
    username: "Mike_Johnson",
    joinedAt: "2025-01-20",
    coins: 62100,
    ownedBlocks: 15,
    totalBuildings: 22,
    hourlyIncome: 1050,
    auctionWins: 8,
  },
  {
    id: "user-005",
    username: "Sarah_Lee",
    joinedAt: "2025-03-01",
    coins: 19400,
    ownedBlocks: 6,
    totalBuildings: 8,
    hourlyIncome: 280,
    auctionWins: 2,
  },
  {
    id: "user-006",
    username: "Ivan_Petrov",
    joinedAt: "2025-02-10",
    coins: 38700,
    ownedBlocks: 11,
    totalBuildings: 16,
    hourlyIncome: 660,
    auctionWins: 6,
  },
  {
    id: "user-007",
    username: "Jake_Williams",
    joinedAt: "2025-03-15",
    coins: 14200,
    ownedBlocks: 4,
    totalBuildings: 5,
    hourlyIncome: 150,
    auctionWins: 1,
  },
  {
    id: "user-008",
    username: "Wei_Chen",
    joinedAt: "2025-01-05",
    coins: 55300,
    ownedBlocks: 14,
    totalBuildings: 20,
    hourlyIncome: 890,
    auctionWins: 7,
  },
  {
    id: "user-009",
    username: "Priya_Sharma",
    joinedAt: "2025-02-20",
    coins: 23600,
    ownedBlocks: 7,
    totalBuildings: 10,
    hourlyIncome: 370,
    auctionWins: 2,
  },
  {
    id: "user-010",
    username: "Carlos_Silva",
    joinedAt: "2025-01-28",
    coins: 41900,
    ownedBlocks: 10,
    totalBuildings: 15,
    hourlyIncome: 610,
    auctionWins: 4,
  },
  {
    id: "user-011",
    username: "Yuki_Suzuki",
    joinedAt: "2025-04-01",
    coins: 8900,
    ownedBlocks: 3,
    totalBuildings: 3,
    hourlyIncome: 110,
    auctionWins: 0,
  },
  {
    id: "user-012",
    username: "Maria_Oliveira",
    joinedAt: "2025-03-20",
    coins: 16700,
    ownedBlocks: 5,
    totalBuildings: 7,
    hourlyIncome: 240,
    auctionWins: 1,
  },
];
